import { render, staticRenderFns } from "./cancellation-and-amendment-policy.vue?vue&type=template&id=8a990b1e&scoped=true"
import script from "./cancellation-and-amendment-policy.vue?vue&type=script&lang=ts"
export * from "./cancellation-and-amendment-policy.vue?vue&type=script&lang=ts"
import style0 from "./cancellation-and-amendment-policy.vue?vue&type=style&index=0&id=8a990b1e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a990b1e",
  null
  
)

export default component.exports